import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { PmsUIAppModule } from './PmsUIApp/PmsUIApp.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(PmsUIAppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
